import axiosInstance from 'api/axiosInstance';

export interface UpdateCheckpointPayload {
  CheckpointID: number;
  Time?: string;
  DateTime?: string | null;
  Comment: string;
  SelectedStatusID: number | null;
  SelectedDropdownIDs?: number[];
}

export const updateCheckpointReport = async (
  payload: UpdateCheckpointPayload
): Promise<any> => {
  try {
    // Uses the same endpoint as cantrackv3 - SubmitChecklistV3
    // Payload must be JSON stringified array
    const response = await axiosInstance.post(
      '/api/CANDispatch/SubmitChecklistV3',
      {
        payload: JSON.stringify([payload]),
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }
    );

    return response.data;
  } catch (error: any) {
    console.error('Error updating checkpoint report:', error);
    console.error('Error response:', error.response?.data);
    throw error;
  }
};

export default updateCheckpointReport;
